import React, { Component } from 'react';
import { Link } from "react-router-dom"
import { Col, Row, Card } from 'antd';
import { Spin, Table, Tag } from 'antd';
import { Typography } from 'antd';
import axios from 'axios'

const { Title } = Typography;

export default class PortfolioList extends Component {
  state = {
    portfolio_data: [],
    loading: true,
    filteredInfo: null,
    sortedInfo: null,
  }

  componentDidMount() {
    axios('/record/portfolio_list', {
      method: "POST",
      headers: { "Content-Type": "application/json; charset=utf-8" },
    }).then(res => {
      const { portfolios, students } = res.data;
      const data = portfolios.map((pf, i) => ({
        ...pf,
        key: pf.id,
        student: students[i],
        index: i,
      }));
      this.setState({ portfolio_data: data, loading: false });
    });
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({ filteredInfo: filters, sortedInfo: sorter });
  };

  render() {
    if (this.state.loading) {
      return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}><Spin size="large" tip="로딩 중..." /></div>;
    }

    let { sortedInfo, filteredInfo } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};

    const STATUS_MAP = { 'waiting': '승인대기', 'done': '승인완료' };
    const STATUS_COLOR = { '승인대기': 'gray', '승인완료': 'blue', '반려': 'volcano' };

    const columns = [
      {
        title: '신청 날짜',
        dataIndex: 'createdAt',
        key: 'date',
        render: (createdAt, record) => (
          <Link to={`/portfolio_detail/${record.id}`}>
            {new Date(createdAt).toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </Link>
        ),
        sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
        sortOrder: sortedInfo.columnKey === 'date' && sortedInfo.order,
      },
      {
        title: '선택 실습 수',
        dataIndex: 'record_ids',
        key: 'record_n',
        render: (record_ids) => record_ids ? record_ids.length : '',
      },
      {
        title: '신청 용도',
        dataIndex: 'purpose',
        key: 'purpose',
        filters: [...new Set(this.state.portfolio_data.map(d => d.purpose).filter(Boolean))].sort()
          .map(v => ({ text: v, value: v })),
        filteredValue: filteredInfo.purpose || null,
        onFilter: (value, record) => record.purpose === value,
      },
      {
        title: '지도 학생',
        dataIndex: 'student',
        key: 'student',
        filters: [...new Set(this.state.portfolio_data.map(d => d.student).filter(Boolean))].sort()
          .map(v => ({ text: v, value: v })),
        filteredValue: filteredInfo.student || null,
        onFilter: (value, record) => record.student === value,
      },
      {
        title: '상태',
        key: 'status',
        dataIndex: 'status',
        filters: [
          { text: '승인대기', value: 'waiting' },
          { text: '승인완료', value: 'done' },
        ],
        filteredValue: filteredInfo.status || null,
        onFilter: (value, record) => record.status === value,
        render: status => {
          const isReject = typeof status === 'string' && status.startsWith('반려');
          const status_kr = isReject ? '반려' : (STATUS_MAP[status] || status);
          const color = STATUS_COLOR[status_kr];
          return <Tag color={color} key={status}>{status_kr}</Tag>;
        },
      },
    ];

    return (
      <Col xs={{ span: 22, offset: 1 }} sm={{ span: 20, offset: 2 }} md={{ span: 20, offset: 2 }} lg={{ span: 20, offset: 2 }} xxl={{ span: 16, offset: 4 }} style={{ marginTop: '40px' }}>
        <Card>
          <Row span={12}>
            <Col><Title level={3}>신청된 포트폴리오 현황</Title></Col>
          </Row>
          <Row span={12}>
            <Col span={24}>
              <Table key='portfolio' columns={columns} dataSource={this.state.portfolio_data} onChange={this.handleChange} />
            </Col>
          </Row>
        </Card>
      </Col>
    );
  }
}
